import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import AttendanceCategories from "./routes/AttendanceCategories";
import UserNameSettings from "./routes/UserNameSettings";
import ModuleSettings from "./routes/ModuleSettings";
import ModuleSettingsV2 from "./routes/ModuleSettingsV2";
import StudentAlertsSettings from "./routes/StudentAlertsSettings";
import { getNextMenuRoute } from "Administrator/modules/AdministratorModule";
import { getRelativePath } from "Utils";

export default store => ({
  path: "school-settings",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "schoolSettings" */ "./components/SchoolSettings"
        ),
        import(
          /* webpackChunkName: "schoolSettings" */ "./modules/SchoolSettingsModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "schoolSettings",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    if (_.last(nextState.routes).path == "school-settings") {
      const route = getNextMenuRoute("SCHOOL_SETTINGS_MODULE");
      if (route) {
        replace(getRelativePath(route));
      } else {
        replace(getRelativePath("../"));
      }
    }
  },
  childRoutes: [
    AttendanceCategories(store),
    UserNameSettings(store),
    ModuleSettings(store),
    ModuleSettingsV2(store),
    StudentAlertsSettings(store),
  ],
});
